/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { webParseGetWebparseExtractimages } from "../../funcs/webParseGetWebparseExtractimages.js";
import { GetWebparseExtractimagesRequest$zodSchema } from "../../models/getwebparseextractimagesop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetWebparseExtractimagesRequest$zodSchema,
};

export const tool$webParseGetWebparseExtractimages: ToolDefinition<
  typeof args
> = {
  name: "web-parse-get-webparse-extractimages",
  description: `提取网页图片

想批量获取一个网页上的所有图片链接？这个接口帮你搞定。

## 功能概述
提供一个网页 URL，返回该页面中所有图片的链接列表。适合用于图片采集、素材下载等场景。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await webParseGetWebparseExtractimages(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
